import { Datepicker } from 'vanillajs-datepicker';
import { formSubmissionMixin } from './form-submission.mixin';
import moment from 'moment';
import _ from 'lodash';

export const fieldsMixin = {
    mixins: [formSubmissionMixin],

    data() {
        return {
            all_fields: {},
            form_fields: [],
            local_fields: [],
            datepicker: false,
            date: new Date()
        }
    },

    mounted() {

        this.parseFields();
        // this.$refs.appointmentWrapper.style.display = 'block';
    },

    watch: {
        all_fields() {
            this.populateLocalFields();
        },

        local_fields: {
            deep: true,
            handler(value) {
                Object.keys(value).forEach(key => {
                    Object.keys(value[key]).forEach(item => {
                        value[key][item].type == 'date' && this.initDatePickers();
                    });
                });
            }
        }

    },

    computed: {
        conditions() {
            let form = JSON.parse(document.getElementById('formFields').innerHTML);
            let ticket_forms = form.ticket_forms;
            let parsed = {};

            ticket_forms.forEach(ticketForm => {
                if (ticketForm.agent_conditions.length) {
                    let form = ticketForm.id;

                    parsed[form] = ticketForm.agent_conditions;
                }
            });

            return parsed;
        }
    },

    methods: {
        manageCondition(event, formId, id, value) {
            if (this.conditions[formId]) {
                let form = this.conditions[formId];
                this.resetCondition(formId, id);

                form.forEach(item => {
                    let fields = item.child_fields;
                    fields.forEach(field => {
                        if (item.parent_field_id == id && item.value == value) {

                            if (this.local_fields[formId][field.id]) {
                                this.local_fields[formId][field.id]['is_shown'] = true;
                            }
                        }

                    });
                });
            }
        },

        resetCondition(formId, fieldId) {
            this.conditions[formId].forEach(form => {
                if (fieldId == form.parent_field_id) {
                    form.child_fields.forEach(field => {
                        if (this.local_fields[formId][field.id]) {
                            this.local_fields[formId][field.id].is_shown = false;
                        }
                    });
                }
            })
        },

        parseFields() { // Convert fields to object with id as key for easier cherry picking

            let form = JSON.parse(document.getElementById('ticketFields').innerHTML);

            let fields = form.ticket_fields;
            let all_fields = {};


            this.getTicketId(form);

            fields.forEach(item => {
                all_fields[item.id] = item;
                let value = item.type == 'multiselect' ? [] : '';
                all_fields[item.id]['data'] = value;
                all_fields[item.id]['has_error'] = false;
                all_fields[item.id]['is_shown'] = true;
            });

            this.all_fields = all_fields;
        },

        getTicketId(ticketForm = {}) {
            this.ticket_id = ticketForm['id'] || 0;
        },

        listFields(field_ids = []) {
            field_ids.length && field_ids.forEach(item => {
                this.form_fields.push(this.fields[item]);
            });
        },

        initDatePickers() {
            const self = this;

            const waitDatepickerDom = setInterval(() => {
                const elems = document.querySelectorAll('.datepicker-dom');

                if (elems.length) {


                    elems.forEach((item, index) => {
                        const datepicker = new Datepicker(item, {
                            format: 'DD, dd MM yyyy'
                        });

                        item.addEventListener('changeDate', event => {
                            item.dataset.date = moment(event.detail.date).format('YYYY-MM-DD');
                            self.local_fields[item.dataset.form][item.dataset.field].data = item.dataset.date;
                        })
                    });

                    clearInterval(waitDatepickerDom);
                }
            }, 1000)

        },

        stopEvent(event) {
            event.stopPropagation();
        },

        populateLocalFields() {
            let form = JSON.parse(document.getElementById('formFields').innerHTML);
            let ticket_forms = form.ticket_forms;
            let local_fields = {};



            ticket_forms.forEach(ticketForm => {
                local_fields[ticketForm['id']] = {};
                ticketForm.ticket_field_ids.forEach(item => {
                    let fieldItem = this.all_fields[item];
                    let conditions = this.conditions[ticketForm['id']];
                    if (fieldItem.editable_in_portal) {
                        let fieldId = fieldItem.id;
                        let formId = ticketForm['id'];
                        local_fields[formId][fieldId] = {}
                        local_fields[formId][fieldId] = fieldItem;

                        if (!conditions) {
                            local_fields[formId][fieldId].is_shown = true;
                        } else {
                            Object.keys(conditions).forEach(key => {
                                let parent = conditions[key];

                                parent.child_fields.forEach(child_field => {
                                    if (local_fields[formId][child_field.id]) {
                                        local_fields[formId][child_field.id].is_shown = false;
                                    }
                                });
                            })
                        }
                    }

                });
            });
            this.local_fields = local_fields;

        },

        // For multi-select
        removeSelection(index, field_id, id) {
            this.local_fields[index][field_id]['data'].forEach((item, index) => {
                if (item.id == id) {
                    this.local_fields[index][field_id]['data'].splice(index, 1);
                }
            })
        },


    }
}